export enum DelegationStatus {
  PLANNED = 'planned',
  ACTIVE = 'active',
  UNSETTLED = 'unsettled',
  SETTLED = 'settled',
  ARCHIVED = 'archived',
  CANCELED = 'canceled',
}
